import {IWuAppHeaderMenuItem} from '../types/WuAppHeaderMenuItem'

enum KeyboardKey {
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Tab = 'Tab',
  Enter = 'Enter',
  Space = ' ',
}

export function createHandleKeyDown({
  productCategories,
  openCategory,
  setOpenCategory,
}: {
  productCategories: IWuAppHeaderMenuItem[]
  openCategory: IWuAppHeaderMenuItem | null
  setOpenCategory: (category: IWuAppHeaderMenuItem | null) => void
}) {
  const moveFocus = (
    newIndex: number,
    items: NodeListOf<HTMLElement>,
  ): void => {
    const newItem = items[newIndex]
    if (newItem) {
      newItem.focus()
      const newCategory = productCategories[newIndex] || null
      setOpenCategory(newCategory)
    }
  }

  const handleArrowNavigation = (
    event: React.KeyboardEvent,
    index: number,
    direction: 'up' | 'down',
    items: NodeListOf<HTMLElement>,
  ): void => {
    event.preventDefault()
    const newIndex = direction === 'down' ? index + 1 : index - 1
    moveFocus(newIndex, items)
  }

  const handleTabNavigation = (
    event: React.KeyboardEvent,
    index: number,
    items: NodeListOf<HTMLElement>,
    focusItem: string,
  ): void => {
    if (openCategory?.products) {
      const lastProduct =
        openCategory.products[openCategory.products.length - 1]
      if (lastProduct.name === focusItem) {
        event.preventDefault()
        moveFocus(index + 1, items)
      }
    }
  }

  const handleEnterOrSpace = (
    event: React.KeyboardEvent,
    index: number,
  ): void => {
    event.preventDefault()
    const selectedCategory =
      productCategories[index] === openCategory
        ? null
        : productCategories[index]
    setOpenCategory(selectedCategory)
  }

  return function handleKeyDown(
    event: React.KeyboardEvent,
    index: number,
    focusItem: string,
  ): void {
    const items = document.querySelectorAll(
      '.productCategory',
    ) as NodeListOf<HTMLElement>
    const {key} = event

    switch (key) {
      case KeyboardKey.ArrowDown:
        handleArrowNavigation(event, index, 'down', items)
        break
      case KeyboardKey.ArrowUp:
        handleArrowNavigation(event, index, 'up', items)
        break
      case KeyboardKey.Tab:
        handleTabNavigation(event, index, items, focusItem)
        break
      case KeyboardKey.Enter:
      case KeyboardKey.Space:
        handleEnterOrSpace(event, index)
        break
      default:
        break
    }
  }
}
